/** 모바일 — 재고 조회. 카드를 누르면 입고분(lot)별 잔량·단가·유통기한 */
import React, { useMemo, useState } from 'react';
import { stockSummary, lotsOf, num, fmt } from 'shop/shopStore';
import { Page, H, CardBox, Field, Chip } from './mobileUi';

const MobileStock = ({ tc }) => {
  const [kw, setKw] = useState('');
  const [open, setOpen] = useState('');
  const rows = useMemo(() => {
    const q = kw.trim().toLowerCase();
    return stockSummary(tc)
      .filter((s) => s.useYn !== 'N')
      .filter((s) => !q || `${s.productCode} ${s.productNm} ${s.category}`.toLowerCase().includes(q))
      .sort((a, b) => Number(b.lowStock) - Number(a.lowStock) || String(a.productNm).localeCompare(String(b.productNm)));
  }, [tc, kw]);

  return (
    <Page>
      <H>재고</H>
      <Field>검색
        <input value={kw} onChange={(e) => setKw(e.target.value)} placeholder="코드·제품명·분류" />
      </Field>
      {rows.length === 0 && <span className="s">제품이 없습니다.</span>}
      {rows.map((s) => (
        <CardBox key={s.productUid} $warn={s.lowStock} $tap onClick={() => setOpen(open === s.productUid ? '' : s.productUid)}>
          <span className="t">{s.productNm} {s.lowStock && <Chip $warn>부족</Chip>}</span>
          <span className="n">{fmt(s.remainQty)}{s.useUnit}</span>
          <span className="s">안전재고 {fmt(s.safetyQty)}{s.useUnit} · 재고금액 ₩{fmt(s.stockAmount)}</span>
          {open === s.productUid && lotsOf(tc, s.productUid).filter((l) => num(l.remainQty) > 0).map((l) => (
            <span className="s" key={l.lotUid}>
              {l.inDate} 입고 · 잔량 {fmt(l.remainQty)}{s.useUnit} · 단가 ₩{fmt(Math.round(num(l.unitCost)))}{l.expiryDate ? ` · 유통 ${l.expiryDate}` : ''}
            </span>
          ))}
        </CardBox>
      ))}
    </Page>
  );
};

export default MobileStock;
